// @ts-nocheck
import React, { useState } from 'react';
import { sx } from '../sx';
import { SEGMENTS, SELECT } from '../controls';
import InfoTip from './InfoTip';
import CohortSwitch from './CohortSwitch';

const N_MIN = 1;
const N_MAX = 12;

const fit = (rule, c) => {
  const next = { method: rule.method, n: Math.max(N_MIN, Math.min(N_MAX, rule.n || 3)) };
  if (rule.season && c.seasonOk) next.season = true;
  if (rule.trend && c.trendOk(rule.method)) next.trend = true;
  return next;
};

export default function CohortChipPopover({ c }: { c: any }) {
  const [own, setOwn] = useState(!!c.own);
  const [rule, setRule] = useState(() => fit(c.own || c.tab, c));
  const method = (c.methods || []).find(m => m.id === rule.method);
  const trendOk = c.trendOk(rule.method);
  const set = patch => setRule(r => fit(Object.assign({}, r, patch), c));
  const choice = (selected, label, onClick) => (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      style={sx(`flex:1;height:28px;padding:0 12px;border:none;font-family:inherit;font-size:12px;font-weight:${selected ? 500 : 400};background:${selected ? '#0052CD' : '#fff'};color:${selected ? '#fff' : 'var(--ink-2)'};cursor:pointer`)}
    >
      {label}
    </button>
  );
  return (
    <div data-pop="cohortRule" role="dialog" aria-label={c.title} data-testid="cohort-chip-popover" onClick={e => e.stopPropagation()} style={sx(`position:absolute;top:calc(100% + 4px);left:14px;z-index:40;width:320px;padding:12px;border:1px solid #DCE4F2;border-radius:10px;background:#fff;box-shadow:0 8px 24px rgba(8,35,76,0.12);cursor:default`)}>
      <div style={sx(`font-size:12.5px;font-weight:600;color:var(--ink)`)}>{c.title}</div>
      <p style={sx(`margin:3px 0 10px;font-size:11.5px;line-height:1.45;color:var(--ink-3)`)}>{c.note}</p>
      <div style={sx(`${SEGMENTS};width:100%`)}>
        {choice(!own, 'Same as tab', () => setOwn(false))}
        {choice(own, 'Own choice', () => setOwn(true))}
      </div>
      {own ? (
        <div style={sx(`display:flex;flex-direction:column;gap:8px;margin-top:10px`)}>
          <span style={sx(`display:flex;align-items:center;gap:6px`)}>
            <select aria-label="cohort forecast method" value={rule.method} onChange={e => set({ method: e.target.value })} style={sx(`${SELECT};flex:1;min-width:0`)}>
              <optgroup label="Main options">
                {(c.methods || []).filter(m => m.group === 'main').map(m => <option key={m.id} value={m.id}>{m.label}</option>)}
              </optgroup>
              <optgroup label="Other options">
                {(c.methods || []).filter(m => m.group === 'other').map(m => <option key={m.id} value={m.id}>{m.label}</option>)}
              </optgroup>
            </select>
            <InfoTip text={method ? method.tip : ''} label="Forecast method" />
          </span>
          <div className="gmField" style={sx(`${SEGMENTS};align-items:center;align-self:flex-start`)}>
            <button type="button" aria-label="Fewer" disabled={rule.n <= N_MIN} onClick={() => set({ n: rule.n - 1 })} style={sx(`flex:none;width:28px;height:28px;border:none;background:none;font-family:inherit;font-size:15px;color:${rule.n > N_MIN ? '#0052CD' : '#C8D4EA'};cursor:pointer`)}>−</button>
            <span data-testid="cohort-chip-n" style={sx(`min-width:18px;text-align:center;font-size:12px;font-weight:600;font-variant-numeric:tabular-nums`)}>{rule.n}</span>
            <button type="button" aria-label="More" disabled={rule.n >= N_MAX} onClick={() => set({ n: rule.n + 1 })} style={sx(`flex:none;width:28px;height:28px;border:none;background:none;font-family:inherit;font-size:15px;color:${rule.n < N_MAX ? '#0052CD' : '#C8D4EA'};cursor:pointer`)}>+</button>
            <span style={sx(`flex:none;padding-right:12px;font-size:12px;color:var(--ink-3)`)}>{rule.method === 'prev' ? 'months back' : 'cohorts'}</span>
          </div>
          <CohortSwitch label="Monthly seasonality" on={!!rule.season} disabled={!c.seasonOk} tip={c.seasonTip} onToggle={() => set({ season: !rule.season })} />
          <CohortSwitch label="Year on year trend" on={!!rule.trend} disabled={!trendOk} tip={c.trendTipOf(rule.method)} onToggle={() => set({ trend: !rule.trend })} />
        </div>
      ) : null}
      <div style={sx(`display:flex;justify-content:flex-end;gap:6px;margin-top:12px`)}>
        <button type="button" className="gmHover" onClick={c.onCancel} style={sx(`height:26px;padding:0 12px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:11.5px;cursor:pointer`)} data-hover="border-color:#0052CD">Cancel</button>
        <button type="button" onClick={() => c.onApply(own ? rule : null)} style={sx(`height:26px;padding:0 12px;border:none;border-radius:999px;background:#0052CD;color:#fff;font-family:inherit;font-size:11.5px;cursor:pointer`)}>Apply</button>
      </div>
    </div>
  );
}
